<template>
  <b-container class="analysis-processing" fluid>
    <b-row no-gutters align-h="end">
      <b-col cols="12" sm="6" lg="3">
        <b-row v-show="lastLoad">
          <b-col cols="12" class="analysis-processing__time-label text-center">
            <label> {{ $t('fields.general.last-execution') }}: </label>
            <span>
              {{
                this.lastLoad
                  | dateTimeFilter({ format: formats.DATETIME_SHORT })
              }}
            </span>
          </b-col>
        </b-row>
        <b-row no-gutters>
          <b-col cols="6" class="pr-1">
            <b-button
              block
              variant="outline-secondary"
              size="sm"
              @click="print"
            >
              <span class="fas fa-print mr-1" />
              {{ $t('buttons.print') }}
            </b-button>
          </b-col>
          <b-col cols="6" class="pl-1">
            <s-loading-button
              block
              variant="outline-secondary"
              size="sm"
              @click="fireRefresh"
            >
              <template #icon>
                <span class="fas fa-sync-alt" />
              </template>
              {{ $t('buttons.refresh') }}
            </s-loading-button>
          </b-col>
        </b-row>
        <b-row no-gutters class="mt-2">
          <b-col cols="8" class="pr-1">
            <b-button
              block
              variant="outline-green"
              @click="downloadTemplate"
            >
              <span class="fas fa-file-excel mr-2" />
              {{ $t('actions.template-download') }}
            </b-button>
          </b-col>
          <b-col cols="4" class="pl-1">
            <b-button
              @click="showHelpModal"
              block
              variant="outline-secondary"
              class="help-button"
              ><span class="far fa-question-circle mr-2" />
              {{ $t('buttons.help') }}</b-button
            >
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>
<style lang="sass" scoped>
.analysis-processing
  &__time-label
    opacity: .7
.help-button
    min-width: 1rem !important
    text-transform: none !important
    font-size: 0.875rem !important
</style>

<script>
import AnalysisProcessingService from '@/domain/services/installation/engineering/analysisProcessing';
import print from '@/services/print';
import { formats } from '@/constants/localizer';

export default {
  props: {
    lastLoad: {
      type: String,
      required: false,
    },
  },
  data: () => ({ formats }),
  methods: {
    downloadTemplate() {
      AnalysisProcessingService.downloadTemplate();
    },
    print,
    fireRefresh({ wait }) {
      this.$emit('refresh', { wait });
    },
    showHelpModal() {
      this.$emit('show-modal');
    },
  },
};
</script>
